/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mLucky.vue?vue&type=template&id=5c4350e9&scoped=true"
import script from "./mLucky.vue?vue&type=script&lang=js"
export * from "./mLucky.vue?vue&type=script&lang=js"
import style0 from "./mLucky.vue?vue&type=style&index=0&id=5c4350e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4350e9",
  null
  
)

export default component.exports